import { render } from "./BaseIntroBlock.vue?vue&type=template&id=424970ab&scoped=true"
import script from "./BaseIntroBlock.vue?vue&type=script&lang=js"
export * from "./BaseIntroBlock.vue?vue&type=script&lang=js"

import "./BaseIntroBlock.vue?vue&type=style&index=0&id=424970ab&lang=scss&scoped=true"
import "./BaseIntroBlock.vue?vue&type=style&index=1&lang=scss"
script.render = render
script.__scopeId = "data-v-424970ab"

export default script